var map = {
	"./block_height.png": "d6zC",
	"./dm_logo.png": "CaUA",
	"./footLOGO.png": "ecad",
	"./footer.png": "or/K",
	"./gsx_footer.png": "0rXm",
	"./gsx_footerLogo.png": "A67j",
	"./gsx_invalidSearch.png": "BJJJ",
	"./gsx_navLogo.png": "AzD2",
	"./gsx_view.png": "XJMm",
	"./invalidSearch.png": "HWVS",
	"./navbar_logo.png": "BTxe",
	"./total_trade.png": "icr9",
	"./view.png": "xw+N"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "zfj7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img ^\.\/.*\.png$
// module id = zfj7
// module chunks = 8